import React from 'react'
import LopiContainer from "./components/LopiContainer"
import 'bootstrap/dist/css/bootstrap.min.css'


function App(props) {

  return (
    <LopiContainer client={props.client} />
  );
}

export default App;
